import React from "react";
import {
  FooterCreditsContainer,
  CreditsContainer,
  FooterColumn,
  Border,
  Break,
} from "../styles/components/Global/Global";
import {
  Paragraph,
  ParagraphContainer,
  TextContainer,
} from "../styles/components/Global/Paragraph";

const FooterCredits = () => {
  return (
    <>
      <FooterCreditsContainer>
        <FooterColumn $justify="flex-start" $noGrow $desktop>
          <Paragraph $size="small" $bold>
            A$AP ROCKY
          </Paragraph>
        </FooterColumn>
        <FooterColumn $justify="center" $direction="row" $noWidth>
          <Border />
          <Paragraph $size="normal" $bold>
            STORY CREDITS
          </Paragraph>
          <Border />
        </FooterColumn>
        <FooterColumn $justify="flex-end" $noGrow $desktop>
          <Paragraph $size="small" $bold>
            HIGHSNOBIETY
          </Paragraph>
        </FooterColumn>
      </FooterCreditsContainer>
      <CreditsContainer $direction="column">
        <FooterColumn $align="center" $direction="column" $margin $noWidth>
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">BY:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                JORDAN COLEY&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">PHOTOGRAPHY:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                RYAN MCGINLEY&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">STYLING:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                SEBASTIAN JEAN&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
        </FooterColumn>
        <FooterColumn $align="center" $direction="column" $margin $noWidth>
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">EXECUTIVE PRODUCER:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                TRISTAN RODRIGUEZ&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">SET:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                JAVIER IRIGOYEN&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">SKIN:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                MICHELLE WALDRON&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">HAIR:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                TASHANA MILES&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">HAIR ASSISTANT:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                NATASHA BREWSTER&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">MANICURE:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                SONYA MEESH&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">CHOREOGRAPHER:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                LUISA OPALESKY&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">PRODUCTION:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                T • CREATIVE&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">PRODUCTION MANAGER:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                MEHOW PODSTAWSKI&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">
                PRODUCTION COORDINATOR: &nbsp;
              </Paragraph>
              <Paragraph $style="deville" $size="credits">
                ZANE HOLLEY&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">SPECIAL THANKS:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                MATTHEW HENSON&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">STYLIST ASSISTANT:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                BRITTANY BRYANT&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
          <Break />
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">PRODUCT MANAGER:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                SHAUN ROACH&nbsp;
              </Paragraph>
            </ParagraphContainer>
            <ParagraphContainer>
              <Paragraph $size="small">CREATIVE DEVELOPER:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                BELEN JONES&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
          <TextContainer $direction="row" $mobileColumn>
            <ParagraphContainer>
              <Paragraph $size="small">DIGITAL ART DIRECTOR:&nbsp;</Paragraph>
              <Paragraph $style="deville" $size="credits">
                LISLE ABRAHAMS&nbsp;
              </Paragraph>
            </ParagraphContainer>
          </TextContainer>
        </FooterColumn>
      </CreditsContainer>
      <FooterCreditsContainer>
        <FooterColumn $justify="center" $direction="row" $noWidth>
          <Border />
        </FooterColumn>
      </FooterCreditsContainer>
    </>
  );
};

export default FooterCredits;
